import { AppThunkAction } from "..";
import { KnownAction, USER_DOCUMENTS_AND_IMAGES_SHOW_LOADER, RECEIVE_USER_DOCUMENTS_AND_IMAGES } from "./types";
import * as httpClient from "../../util/httpClient";

export const actionCreators = {
    getDocumentsAndImagesData: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: USER_DOCUMENTS_AND_IMAGES_SHOW_LOADER, isLoading: true });
        httpClient
            .sendRequest("POST", `api/securevault/getUserFileList`)
            .then((data) => {
                dispatch({
                    type: RECEIVE_USER_DOCUMENTS_AND_IMAGES,
                    vaultFileList: data["vaultList"] ? data["vaultList"].reverse() : [],
                    totalFileSize: data["totalFileSize"] ? data["totalFileSize"] : 0,
                });
                dispatch({ type: USER_DOCUMENTS_AND_IMAGES_SHOW_LOADER, isLoading: false });
            })
            .catch(function (error) {
                const temp = error;
                dispatch({ type: USER_DOCUMENTS_AND_IMAGES_SHOW_LOADER, isLoading: false });
            });
    },
};
